export default __webpack_public_path__ + "9053572c46aeb4b16caafd643a543b8d.woff";